import { useCallback } from 'react';

import { useAuthContext } from './useAuthContext';

/*
  Wraps window.HudLauncher.open with the current auth token so HUD can
  authenticate via message-passing instead of the legacy popup flow.
*/
export function useHudLauncher() {
  const { token } = useAuthContext();

  return useCallback(
    (url, options = {}) => {
      if (!window.HudLauncher?.open) return null;

      return window.HudLauncher.open(url, {
        ...options,
        getToken: async () => token,
      });
    },
    [token],
  );
}
